module.exports = __webpack_public_path__ + "img/nz.aee968e5.svg";